import { IHeadlineLineItemBreakdownAccommodationLineItem } from 'services/BookingManagerApi';
import { IBookingManagerHotelDetails } from './types';

export const GET_HOTEL_DETAILS_REQUEST = 'bookingManager_hotelDetails/GET_HOTEL_DETAILS_REQUEST';
export const GET_HOTEL_DETAILS_SUCCESS = 'bookingManager_hotelDetails/GET_HOTEL_DETAILS_SUCCESS';
export const GET_HOTEL_DETAILS_FAILURE = 'bookingManager_hotelDetails/GET_HOTEL_DETAILS_FAILURE';

export const SET_RESORT_CONFIRMATION_NUMBER = 'bookingManager_hotelDetails/SET_RESORT_CONFIRMATION_NUMBER';

export const PATCH_HOTEL_DETAILS_REQUEST = 'bookingManager_hotelDetails/PATCH_HOTEL_DETAILS_REQUEST';
export const PATCH_HOTEL_DETAILS_SUCCESS = 'bookingManager_hotelDetails/PATCH_HOTEL_DETAILS_SUCCESS';
export const PATCH_HOTEL_DETAILS_FAILURE = 'bookingManager_hotelDetails/PATCH_HOTEL_DETAILS_FAILURE';

export const HANDLE_REMOVE_ACCOMMODATION = 'bookingManager_hotelDetails/HANDLE_REMOVE_ACCOMMODATION';
export const SET_HOTEL_DETAILS = 'bookingManager_hotelDetails/SET_HOTEL_DETAILS';

export type GetHotelDetailsRequestAction = ReturnType<typeof getHotelDetailsRequestAction>;
export const getHotelDetailsRequestAction = () => ({
  type: GET_HOTEL_DETAILS_REQUEST as typeof GET_HOTEL_DETAILS_REQUEST,
});

export type GetHotelDetailsSuccessAction = ReturnType<typeof getHotelDetailsSuccessAction>;
export const getHotelDetailsSuccessAction = (hotelDetails: IBookingManagerHotelDetails[]) => ({
  type: GET_HOTEL_DETAILS_SUCCESS as typeof GET_HOTEL_DETAILS_SUCCESS,
  hotelDetails,
});

export type GetHotelDetailsFailureAction = ReturnType<typeof getHotelDetailsFailureAction>;
export const getHotelDetailsFailureAction = (error: string) => ({
  type: GET_HOTEL_DETAILS_FAILURE as typeof GET_HOTEL_DETAILS_FAILURE,
  error,
});

export type SetResortConfirmationNumberAction = ReturnType<typeof setResortConfirmationNumberAction>;
export const setResortConfirmationNumberAction = (hotelUuid: string, resortConfirmationNumber: string) => ({
  type: SET_RESORT_CONFIRMATION_NUMBER as typeof SET_RESORT_CONFIRMATION_NUMBER,
  hotelUuid,
  resortConfirmationNumber,
});

export type HandleRemoveAccommodationAction = ReturnType<typeof handleRemoveAccommodationAction>;
export const handleRemoveAccommodationAction = (hotelUuidsRemaining: string[]) => ({
  type: HANDLE_REMOVE_ACCOMMODATION as typeof HANDLE_REMOVE_ACCOMMODATION,
  hotelUuidsRemaining,
});

export type SetHotelDetailsAction = ReturnType<typeof setHotelDetailsAction>;
export const setHotelDetailsAction = (hotelDetails: IBookingManagerHotelDetails[]) => ({
  type: SET_HOTEL_DETAILS as typeof SET_HOTEL_DETAILS,
  hotelDetails,
});

export type HotelDetailsAction =
  | GetHotelDetailsRequestAction
  | GetHotelDetailsSuccessAction
  | GetHotelDetailsFailureAction
  | SetResortConfirmationNumberAction
  | HandleRemoveAccommodationAction
  | SetHotelDetailsAction;
